import error404Image from "../../Assets/Images/erreur404.png";

export const errorConfigs = {
  error404: {
    imageSrc: error404Image,
    title: "Page non trouvée",
    description: "La page que vous recherchez n'existe pas ou a été déplacée.",
    buttonText: "Menu principal",
    buttonLink: "/comingSoon",
    buttonClassName: "md:w-1/4 w-4/5 lg:-translate-y-16 mx-auto translate-y-44 hover:bg-blue-500 p-2 lg:text-base bg-radio text-center lg:py-2 lg:px-4 rounded-full uppercase md:text-xs"
  },
  error500: {
    imageSrc: error404Image, // Peut être changé pour une image 500
    title: "Erreur serveur",
    description: "Une erreur s'est produite sur nos serveurs. Veuillez réessayer plus tard.",
    buttonText: "Retour à l'accueil",
    buttonLink: "/",
    buttonClassName: "md:w-1/4 w-4/5 lg:-translate-y-16 mx-auto translate-y-44 hover:bg-red-500 p-2 lg:text-base bg-red-600 text-center lg:py-2 lg:px-4 rounded-full uppercase md:text-xs"
  },
  maintenance: {
    imageSrc: error404Image, // Peut être changé pour une image maintenance
    title: "Site en maintenance",
    description: "Nous effectuons actuellement des travaux de maintenance. Merci de revenir plus tard.",
    buttonText: "Actualiser",
    buttonLink: "/",
    buttonClassName: "md:w-1/4 w-4/5 lg:-translate-y-16 mx-auto translate-y-44 hover:bg-yellow-500 p-2 lg:text-base bg-yellow-600 text-center lg:py-2 lg:px-4 rounded-full uppercase md:text-xs"
  }
}; 